
import { Button } from "@/components/ui/button";
import { generateVAPIDKeys } from "@/utils/vapidKeyGenerator";
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";

export const VapidKeyGenerator = () => {
  const [keys, setKeys] = useState<{ publicKey: string; privateKey: string } | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleGenerateKeys = async () => {
    setIsLoading(true);
    
    try {
      const generatedKeys = await generateVAPIDKeys();
      setKeys(generatedKeys);
      
      toast({
        title: "Success",
        description: "VAPID keys generated successfully. Copy them and add them to your Supabase Edge Function secrets.",
      });
    } catch (error) {
      console.error('Error generating VAPID keys:', error);
      
      toast({
        title: "Error",
        description: "Failed to generate keys using the Edge Function. See console for details.",
        variant: "destructive"
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-4 space-y-4">
      <h2 className="text-xl font-bold">VAPID Key Generator</h2>
      <Button onClick={handleGenerateKeys} disabled={isLoading}>
        {isLoading ? "Generating..." : "Generate VAPID Keys"}
      </Button>
      
      {keys && (
        <div className="mt-4 space-y-4">
          <div className="p-4 bg-gray-100 rounded-md">
            <h3 className="font-semibold">Public Key:</h3>
            <p className="break-all mt-2">{keys.publicKey}</p>
          </div>
          <div className="p-4 bg-gray-100 rounded-md">
            <h3 className="font-semibold">Private Key:</h3>
            <p className="break-all mt-2">{keys.privateKey}</p>
          </div>
          <p className="text-sm text-gray-600">
            Copy these keys and add them to your Supabase Edge Function secrets as VAPID_PUBLIC_KEY and VAPID_PRIVATE_KEY
          </p>
        </div>
      )}
    </div>
  );
};
